import { Children, cloneElement, createContext, useContext, useEffect } from "react";

const HelmetContext = createContext(null);

export const HelmetProvider = ({ children }) => children;

const upsertMetaTag = (key, value) => {
  if (!key || !value) return null;

  const selector = `meta[data-codex-helmet="${key}"]`;
  let tag = document.head.querySelector(selector);

  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("data-codex-helmet", key);
    document.head.appendChild(tag);
  }

  if (key.startsWith("property:")) {
    tag.setAttribute("property", key.replace("property:", ""));
  } else {
    tag.setAttribute("name", key.replace("name:", ""));
  }

  tag.setAttribute("content", value);
  return tag;
};

export const Helmet = ({ children }) => {
  const context = useContext(HelmetContext);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;

    const appliedTags = [];

    Children.forEach(children, (child) => {
      if (!child || typeof child !== "object") return;

      if (child.type === "title") {
        document.title = Children.toArray(child.props.children).join("");
        return;
      }

      if (child.type === "meta") {
        const { name, property, content } = child.props || {};
        const key = name ? `name:${name}` : property ? `property:${property}` : null;
        const tag = upsertMetaTag(key, content);
        if (tag) {
          appliedTags.push(tag);
        }
      }
    });

    return () => {
      appliedTags.forEach((tag) => tag.remove());
    };
  }, [children, context]);

  return null;
};

